import {
  call, put, delay,
} from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  checkStatusRollbackVersion, checkStatusRollbackPlansLoopSuccessful, checkStatusRollbackPlansLoopFailed,
  loadLogRollbackVersion,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { BACKEND_URL_V2, ROLLBACK_VERSION_STATUS } from '../../../configs';
import { OK } from '../../../configs/serverStatusCodes';
import {
  setLogList, setProgressList, showProgressBar, stoppedProgressBar,
} from '../../System/actions';
import { dateTimeStringFormatter } from '../../../utils/formatters';

export default function* checkStatusRollbackPlansLoop(action) {
  try {
    const url = `${BACKEND_URL_V2}/audit/rollback-plans/${action?.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true, true);
    const data = yield dataResponse.json();

    if (dataResponse?.status === OK) {
      if (data?.data?.status === ROLLBACK_VERSION_STATUS.NEW && dataResponse?.status === OK) {
        const stopImport = false;
        while (!stopImport) {
          const responsePromise = yield put(checkStatusRollbackVersion(action?.payload));
          const { status } = yield responsePromise;
          if (status === ROLLBACK_VERSION_STATUS.CONFIRMING) {
            break;
          }
          yield delay(2000);
        }
        yield put(checkStatusRollbackPlansLoopSuccessful(data?.data));
        yield call(resolveActionPromise(action, data?.data));
      } else if (data?.data?.status === ROLLBACK_VERSION_STATUS.SUCCESS) {
        const {
          total_items, progress, processed_items,
        } = data.data;
        const logLoadPromise = yield put(loadLogRollbackVersion(action.payload));
        const { data: logs } = yield logLoadPromise;
        yield put(showProgressBar({
          title: 'Процесс восстановления версии',
          text: 'return.version',
        }));
        yield put(setProgressList({
          progressCount: total_items,
          progressPercent: progress,
          progressCountSuccess: processed_items,
        }));
        yield put(setLogList({ log: renderLog(logs) }));
        yield put(stoppedProgressBar());
        yield put(checkStatusRollbackPlansLoopSuccessful());
      }
    } else {
      yield put(checkStatusRollbackPlansLoopFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(checkStatusRollbackPlansLoopFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}

const renderLog = items => {
  const errorMessages = items.map(e => {
    const message = e.message || 'Ошибка без сообщения';
    const timestamp = e.created_at ? `[${dateTimeStringFormatter(e.created_at)}]` : '';
    return `${timestamp} ${message}`;
  });
  return errorMessages.map(msg => `<span>${msg}</span><br/>`);
};
